import { f as faHome, a as faCalendarAlt, b as faClock, c as faAddressBook, d as faPaperPlane, e as faClipboardList } from './index.es-840d4524.js';

var _a, _b;
var Services;
(function (Services) {
    Services["Core"] = "CORE";
    Services["Employment"] = "EMPLOYMENT";
    Services["Schedule"] = "SCHEDULE";
    Services["Survey"] = "SURVEY";
    Services["Time"] = "TIME";
    Services["Notify"] = "NOTIFY";
})(Services || (Services = {}));
var serviceIcons = (_a = {},
    _a[Services.Core] = faHome,
    _a[Services.Schedule] = faCalendarAlt,
    _a[Services.Time] = faClock,
    _a[Services.Employment] = faAddressBook,
    _a[Services.Notify] = faPaperPlane,
    _a[Services.Survey] = faClipboardList,
    _a);
var serviceNames = (_b = {},
    _b[Services.Core] = 'Hem',
    _b[Services.Schedule] = 'Schema',
    _b[Services.Time] = 'Tid',
    _b[Services.Employment] = 'Anställda',
    _b[Services.Notify] = 'Utskick',
    _b[Services.Survey] = 'Undersökning',
    _b);

export { Services, serviceIcons, serviceNames };
//# sourceMappingURL=index.js.map
